export default __webpack_public_path__ + "static/media/hollie.020a94fc.jpg";